import { ShortCode } from '@highereducation/wordpress';
import { TableOfContents, TableOfContentsItem } from '@highereducation/hen-ui';

type TocShortcodeProps = {
  title?: string;
  children?: React.ReactNode;
  [key: string]: unknown;
};

/**
 * TocShortcode - Shortcode wrapper for TableOfContents composite
 *
 * Renders a sidebar "In this Article" navigation with scroll-tracking.
 *
 * When children ([hen-ui-toc-item]) are provided, uses those as explicit items.
 * When no children are provided, the component renders with no items by default.
 * The article-sidebar template provides TOC items via TocItemsProvider context,
 * which is consumed by a wrapper component in hen-site.
 *
 * @example With explicit items
 * [hen-ui-toc title="In this Article"]
 *   [hen-ui-toc-item href="#overview"]Overview[/hen-ui-toc-item]
 *   [hen-ui-toc-item href="#details"]Details[/hen-ui-toc-item]
 * [/hen-ui-toc]
 *
 * @example Auto-discover (items provided by template context)
 * [hen-ui-toc title="In this Article" /]
 */
export const TocShortcode: ShortCode<TocShortcodeProps> = {
  component: ({ title = 'In this Article', children }) => {
    return <TableOfContents title={title}>{children}</TableOfContents>;
  },
};

type TocItemShortcodeProps = {
  href: string;
  children?: React.ReactNode;
  [key: string]: unknown;
};

/**
 * TocItemShortcode - Individual item within a [hen-ui-toc]
 *
 * @example
 * [hen-ui-toc-item href="#section-id"]Section Title[/hen-ui-toc-item]
 */
export const TocItemShortcode: ShortCode<TocItemShortcodeProps> = {
  component: ({ href, children }) => {
    return <TableOfContentsItem href={href}>{children}</TableOfContentsItem>;
  },
};
